import * as React from 'react';
import msgBgTopRight from '../_image/msg_topRight.svg';
import msgBgBottomRight from '../_image/msg_bottomRight.svg';
import msgBgBottomLeft from '../_image/msg_bottomLeft.svg';
import { makeStyles } from '@mui/styles';
import { useSelector, useDispatch } from 'react-redux';
import { alertSelect, alertUpdate } from '../_stores/slice/alert';
import { ButtonCom } from './';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import clsx from 'clsx';


const useStyles = makeStyles((theme) => ({
  hintBox: {
    '& div:has(>.hintRoot)': {
      width: 'fit-content',
      maxWidth: '368px',
      borderRadius: '12px',
      boxShadow: theme.palette.shadow.blue_shadow,
      border: `1px solid ${theme.palette.line.mainLine}`,

      [theme.breakpoints.down('sm')]: {
        maxWidth: '294px',
      },
    },
  },
  root: {
    backgroundImage: `url(${msgBgTopRight}), url(${msgBgBottomRight}), url(${msgBgBottomLeft})`,
    backgroundPosition: 'top right, bottom right, bottom left',
    backgroundRepeat: 'no-repeat',

    '&.hintRoot': {
      backgroundImage: 'none',
      padding: '40px 40px 32px',
      width: 'auto',

      [theme.breakpoints.down('sm')]: {
        padding: '20px 20px 12px',
      },

      '& h2': {
        padding: '0',
      },
    },
  },
  title: {
    color: theme.palette.text.main,
    fontWeight: 700,

    '&.hint': {
      fontWeight: '700',

      [theme.breakpoints.down('sm')]: {
        fontSize: '18px',
      },
    },
  },
  content: {
    padding: '20px 26px',

    '&>div': {
      padding: '5px 0',
    },

    '&.hintContent': {
      padding: '0',
      marginTop: '20px',
      letterSpacing: '-0.5px',

      [theme.breakpoints.down('sm')]: {
        marginTop: '10px',
        fontSize: '14px',
        letterSpacing: '0px',
      },

      '&>div': {
        padding: '0',
      },
    },
  },
  btn: {
    width: 180,

    '&.hint': {
      margin: '12px 0 0',
      width: 'auto',

      '&:not(:first-of-type)': {
        marginLeft: '10px',
      },

      '& button': {
        padding: '8px 24px',
        height: '40px',
      },
    },
  },
}));


/**
 * 提示視窗
 *
 * 使用方式
 *  const [alertDialogOpt, setAlertDialogOpt] = useState(false);
    let alertDialogOption = {
      title: '標題',
      content: '訊息內容' //需為component
      isHintAlert: false //彈出視窗是否要有背景圖
      btn: [{ //無按鈕：空陣列
        name: '按鈕文字',
        fn: 'cloase' or fn() //click時動作：close 為關閉視窗
      }]
    };
 */
export function AlertDialog() {

  const classes = useStyles();
  const dispatch = useDispatch();
  const alertStore = useSelector(alertSelect);
  const alert = alertStore.Dialog;

  const handleClose = () => {
    let newAlertStore = { ...alertStore };
    newAlertStore.Dialog.open = false;
    newAlertStore.Dialog.option = null;
    dispatch(alertUpdate({
      ...newAlertStore
    }));
  };

  const Buttons = () => {

    if (alert.option.btn.length === 0) {
      return false;
    } else {
      const btns = alert.option.btn.map((value, index) => {
        return (
          <Box className={clsx(classes.btn, { 'hint': alert.isHintAlert })} m={4} key={'AlertDialog' + index}>
            <ButtonCom
              id={value.id}
              content={value.name}
              onClick={value.fn === 'close' ? handleClose : value.fn}
              color={(value.fn === 'close' || value.color === 'white') ? 'white' : 'brand'}
              key={'btns_' + index}
            />
          </Box>
        )
      });
      return (
        <DialogActions
          sx={{
            justifyContent: 'center',
          }}
        >
          {btns}
        </DialogActions>
      )
    }
  }

  return (
    <>
      <Dialog
        fullWidth={true}
        open={alert.open}
        // onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        className={clsx({ [classes.hintBox]: alert.isHintAlert })}
      >
        {
          alert.option === null
            ? null
            :
            <Box
              className={clsx(classes.root, { 'hintRoot': alert.isHintAlert })}
            >
              <DialogTitle id='alert-dialog-title' className={clsx(classes.title, { 'hint': alert.isHintAlert })}>
                {alert.option.title}
              </DialogTitle>

              <DialogContent className={clsx(classes.content, { 'hintContent': alert.isHintAlert })}>
                {alert.option.content}
              </DialogContent>

              <Box minHeight={40}>
                <Buttons />
              </Box>

            </Box>
        }

      </Dialog>
    </>
  );
}